import {
  mockGetPreviewDom, mockGetPreviewTransformation, mockGetTransformation, mockGetTransformations,
} from './TransformationsServiceMock';
import { api, mock } from './Api';
import {
  Credentials,
  PreviewTransformationRequest,
  TransformationRequestDto,
  TransformationResponseDto,
} from './ApiType';

const PROTECTED_BASE_PATH = '/api/transformations';
const PUBLIC_BASE_PATH = '/public/transformations';

export async function getTransformations() {
  const { data } = await api.get<TransformationResponseDto[]>(
    PROTECTED_BASE_PATH,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );
  return data;
}

mock.onGet(/\/api\/transformations$/).reply(200, mockGetTransformations);

export async function getTransformation(id: number) {
  const { data } = await api.get<TransformationResponseDto>(
    `${PROTECTED_BASE_PATH}/${id}`,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );
  return data;
}

mock.onGet(/\/api\/transformations\/\d+$/).reply(200, mockGetTransformation);

export async function postTransformation(transformation: TransformationRequestDto) {
  const { headers } = await api.post<void>(
    PROTECTED_BASE_PATH,
    transformation,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  );
  return headers.location.split('/').pop() as number;
}

mock.onPost(/\/api\/transformations$/).reply(200, null, { location: '/api/transformations/1' });

export async function patchTransformation(id: number, transformation: TransformationRequestDto) {
  const { status } = await api.patch<number>(
    `${PROTECTED_BASE_PATH}/${id}`,
    transformation,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    },
  );
  return status;
}

mock.onPatch(/\/api\/transformations\/\d+$/).reply(200, 200);

export async function saveTransformation(id: number, transformation: TransformationRequestDto) {
  if (id > 0) {
    return patchTransformation(id, transformation);
  }

  return postTransformation(transformation);
}

export async function deleteTransformation(id: number) {
  const { status } = await api.delete<number>(
    `${PROTECTED_BASE_PATH}/${id}`,
    {
      headers: {
        Accept: 'application/json',
      },
    },
  );
  return status;
}

mock.onDelete(/\/api\/transformations\/\d+$/).reply(200, 200);

export async function getPreviewDOM(
  url: string,
  credentials?: Credentials,
) {
  const { data } = await api.post<string>(
    `${PUBLIC_BASE_PATH}/preview/dom`,
    credentials,
    {
      params: { url },
      headers: {
        Accept: 'application/xml',
        'Content-Type': 'application/json',
      },
    },
  );
  return data;
}

mock.onPost(/\/public\/transformations\/preview\/dom$/).reply(200, mockGetPreviewDom);

export async function getPreviewTransformation(
  url: string,
  previewTransformationRequest: PreviewTransformationRequest,
) {
  const { data } = await api.post<string>(
    `${PUBLIC_BASE_PATH}/preview/transformation`,
    previewTransformationRequest,
    {
      params: {
        url,
      },
      headers: {
        Accept: 'application/xml',
        'Content-Type': 'application/json',
      },
    },
  );
  return data;
}

mock.onPost(/\/public\/transformations\/preview\/transformation$/).reply(200, mockGetPreviewTransformation);
